<template>
  <otif-checkbox v-model="positive" />
</template>
<script>
export default {
  props: ["rows", "rowNumber"],
  computed: {
    positive: {
      get() {
        if (this.$store.state.localDocuments.documents[this.rowNumber]) {
          return this.$store.state.localDocuments.documents[this.rowNumber]
            .checked;
        } else {
          return false;
        }
      },
      set(value) {
        for (var r = 0; r < this.rows.length; r++) {
          var row = this.rows[r];
          const payload = {
            documentId: r,
            documentName: row["1"],
            checked: false
          };
          this.$store.commit("localDocuments/PUSH_DOCUMENTS", payload);
        }

        var document = this.rows[this.rowNumber];
        this.$store.commit("localDocuments/CHECK_DOCUMENT", {
          documentId: this.rowNumber,
          documentName: document["1"],
          checked: value
        });
      }
    }
  }
};
</script>